import { IconTooltip } from '@anex/common';
import { inject, observer } from 'mobx-react';
import { toTitleCase } from '../../../services/helper';
import * as React from 'react';
export var OrderSummary = inject('appStore', 'planStore', 'checkAddressStore', 'saleStore', 'summaryStore', 'config')(observer(function (props) {
    var _a = React.useState(''), address = _a[0], setAddress = _a[1];
    var _b = props.summaryStore, contractCode = _b.contractCode, sections = _b.sections;
    var wholesaleCustomerCode = props.config.wholesaleCustomerCode;
    var _c = props.checkAddressStore, manualAddress = _c.manualAddress, selectedAddress = _c.selectedAddress, formattedAddress = _c.formattedAddress;
    React.useEffect(function () {
        var isFirstLoad = true;
        if (isFirstLoad) {
            setAddress(breakLine(manualAddress));
            isFirstLoad = false;
        }
    }, []);
    var selectedContract = wholesaleCustomerCode === 'BDF'
        ? props.planStore.getVoipContract(contractCode)
        : props.planStore.getContract(contractCode);
    function breakLine(input) {
        if (input.formattedAddress) {
            return input.formattedAddress
                .split(',')
                .reduce(function (acc, value) { return acc + ",\n" + value; });
        }
        else {
            return (input.unitNumber ? input.unitNumber + '/' : '') +
                (input.streetNumber || '') + " " + (input.streetName ? toTitleCase(input.streetName) : '') + " " + (input.streetType || '') + ",\n          " + (input.suburb ? toTitleCase(input.suburb) : '') + " " + (input.state ||
                '') + " " + (input.postcode || '') + ",\n          Australia";
        }
    }
    function resetForms() {
        props.appStore.gotoState(0);
        props.checkAddressStore.resetManualAddress();
        props.saleStore.reset();
        props.summaryStore.resetSummary();
    }
    return (React.createElement("aside", { className: "order-summary" },
        React.createElement("div", { className: "header" },
            React.createElement("h3", null, wholesaleCustomerCode === 'OT' ? 'Order summary' : 'Order Summary')),
        React.createElement("ul", null,
            selectedContract && (React.createElement(React.Fragment, null,
                React.createElement("li", { className: "order-summary-plan" },
                    React.createElement("h4", { className: "selected-plan" }, "Your selected plan:"),
                    React.createElement("h4", { className: "selected-plan-name" }, selectedContract.name),
                    React.createElement("p", { className: "minimum-total-cost" },
                        "Minimum total cost: $",
                        (props.summaryStore.minimumTotalCost / 100).toFixed(2),
                        selectedContract.length > 0 && selectedContract.length != 24
                            ? " over " + selectedContract.length + " months"
                            : '')),
                sections.map(function (section) {
                    var amount = section.amountOwing / 100;
                    var renderTotal = function (title) {
                        switch (title) {
                            case 'Total':
                                return amount < 0
                                    ? "$" + (amount * -1).toFixed(2) + " CR"
                                    : "$" + amount.toFixed(2);
                            default:
                                return amount < 0
                                    ? "-$" + Math.abs(amount).toFixed(2)
                                    : "$" + amount.toFixed(2);
                        }
                    };
                    return (React.createElement("li", { key: section.title, className: section.title },
                        React.createElement("h4", { className: "component" }, section.title),
                        React.createElement("span", { className: "cost" }, renderTotal(section.title)),
                        React.createElement("p", { className: "description", dangerouslySetInnerHTML: {
                                __html: section.description,
                            } })));
                }),
                sections.map(function (s) {
                    var credit = s.title === 'Total' && s.amountOwing / 100 < 0;
                    return credit ? (React.createElement("div", { className: "information-summary" },
                        React.createElement("p", { className: "small" },
                            React.createElement("span", { style: { marginRight: '8px' } },
                                React.createElement(IconTooltip, { fill: '#fff' })),
                            "Your credit amount of $",
                            ((s.amountOwing / 100) * -1).toFixed(2),
                            " will be deducted from your next bill."))) : null;
                }))),
            React.createElement("li", null,
                React.createElement("h4", { className: "selected-plan" }, "Service address"),
                React.createElement("p", { className: "description", style: { whiteSpace: 'pre-line' } }, formattedAddress),
                React.createElement("p", { className: "minimum-total-cost" },
                    React.createElement("button", { type: "button", className: "btn btn-link text-highlight btn-inline-block pl-0", onClick: function () {
                            resetForms();
                            props.checkAddressStore.resetCheckForm();
                        } }, "Change address"))))));
}));
//# sourceMappingURL=OrderSummary.js.map